import Button from '@mui/material/Button';
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Container } from 'reactstrap';
import Layout from '../components/Layout/Layout';
import protectedPageHOC from '../components/AuthRoute/protectedPageHOC';

const HomePage: React.FC = () => {
  return (
    <Layout header={'Home'} selectedRoute={'/'}>
      <Container>
        <Card>
          <CardBody>
            <p>
              Welcome to this page that is protected by Friebase auth!
            </p>
            <p>
              Change your password <Link to='/change'>here</Link>.
            </p>
            <p>
              Click <Link to='/logout'>here</Link> to logout.
            </p>
            <Button variant='contained'>Authorise with square</Button>
          </CardBody>
        </Card>
      </Container>
    </Layout>
  );
};

export default protectedPageHOC(HomePage);